const TelegramSplashScreen = () => {
    return (
        <div className="tgr-spl-screen"></div>
    )
}

export default TelegramSplashScreen;